import * as React from 'react';

import { AnimatedButton } from 'components/Map/AnimatedButton';
import styles from './GetDirectionsButton.module.css';
import { selectDigitalMap } from 'ducks/universal/digitalMap';
import { useSelector } from 'react-redux';
import { useCurrentPosition } from 'hooks/useCurrentPosition';
import MapDisplayContextService from 'components/Map/MapDisplayContextService';

export const GetDirectionsButton = ({
  pinKey,
  onCloseChat,
  children,
}: {
  pinKey: string;
  onCloseChat: () => void;
  children: React.ReactNode;
}) => {
  const { currentPositionRef } = useCurrentPosition();

  const currentPosition = currentPositionRef.current;

  const digitalMap = useSelector(selectDigitalMap);

  const destinationPin = digitalMap?.pins.find((pin) => pin.key === pinKey);

  return (
    <AnimatedButton
      className={styles.btn}
      clickedClassName={styles.clicked}
      onClick={() => {
        if (currentPosition && destinationPin) {
          MapDisplayContextService.onGetDirections(currentPosition, destinationPin);
          onCloseChat();
        }
      }}
    >
      {children}
    </AnimatedButton>
  );
};
